import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AccionTarea, NuevaTarea } from '../../models/Tarea';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { DateService } from '../../shared/date.service';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDialog } from '@angular/material/dialog';
import { AvanceComponent } from '../../components/tarea/acciones/avance/avance.component';
import { ComentarioComponent } from '../../components/tarea/acciones/comentario/comentario.component';
import { FinalizarComponent } from '../../components/tarea/acciones/finalizar/finalizar.component';
import { CancelarComponent } from '../../components/tarea/acciones/cancelar/cancelar.component';
import { ReabrirComponent } from '../../components/tarea/acciones/reabrir/reabrir.component';
import { DocumentoEstadoPipe } from '../../pipes/documento-estado.pipe';
import { SubestadoTareaPipe } from '../../pipes/subestado-tarea.pipe';
import { DlgAnexosTareaComponent } from '../dlg-anexos-tarea/dlg-anexos-tarea.component';
import { Anexo } from '../../models/Anexo';
import { Router } from '@angular/router';

@Component({
    selector: 'app-documento-tareas',
    imports: [
        MatTableModule,
        MatIconModule,
        MatCardModule,
        MatProgressBarModule,
        MatListModule,
        MatTooltipModule,
        MatButtonModule,
        MatDividerModule,
        SubestadoTareaPipe,
        MatExpansionModule
    ],
    templateUrl: './documento-tareas.component.html',
    styleUrl: './documento-tareas.component.scss'
})
export class DocumentoTareasComponent implements OnChanges {
  @Input() hasParticipated!: boolean
  @Input() isOwner!: boolean
  @Input() tareas!: NuevaTarea[]
  @Input() tipoTarea?: Number
  @Output() successRefresh = new EventEmitter<boolean>()
  @Output() anexosRefresh = new EventEmitter<Anexo[] | undefined>()

  tareasAsignadasPorUsuarioOtrosUsuarios!: NuevaTarea[]
  tareasAsignadasAlUsuario!: NuevaTarea[]

  displayedColumns = ["fecha", "asignado", "comentario", "acciones"]

  constructor(
    private dateService: DateService,
    private router: Router,
    private dlg: MatDialog
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["tareas"] && this.tareas) {
      this.tareasAsignadasAlUsuario = this.tareas.filter((tarea) => tarea.estatus === 0)
      this.tareasAsignadasPorUsuarioOtrosUsuarios = this.tareas.filter((tarea) => tarea.estatus === 1)
    }
  }

  openDlgAnexos(nuevaTarea: NuevaTarea) {
    const dlgDestino = this.dlg.open(DlgAnexosTareaComponent, {
      panelClass: "anexos-panel",
      data: nuevaTarea.id
    });

    dlgDestino.afterClosed().subscribe((result: Anexo[] | undefined) => {
      if (result !== undefined) {
        this.anexosRefresh.emit(result)
      } else {
        this.anexosRefresh.emit()
      }
    });
  }

  opendDlgComentarTarea(nuevaTarea: NuevaTarea) {
    const dlgDestino = this.dlg.open(ComentarioComponent, {
      maxWidth: '90vw',
      data: nuevaTarea
    });

    dlgDestino.afterClosed().subscribe((result: { success: boolean }) => {
      if (result && result.success) {
        this.successRefresh.emit(true)
      }
    });
  }

  opendDlgCancelarTarea(nuevaTarea: NuevaTarea) {
    const dlgDestino = this.dlg.open(CancelarComponent, {
      maxWidth: '90vw',
      data: nuevaTarea
    });

    dlgDestino.afterClosed().subscribe((result: { success: boolean }) => {
      if (result && result.success) {
        this.successRefresh.emit(true)
      }
    });
  }

  opendDlgAvances(nuevaTarea: NuevaTarea) {
    const dlgDestino = this.dlg.open(AvanceComponent, {
      maxWidth: '90vw',
      data: nuevaTarea
    });

    dlgDestino.afterClosed().subscribe((result: { success: boolean }) => {
      if (result && result.success) {
        this.successRefresh.emit(true)
      }
    });
  }

  opendDlgFinalizarTarea(nuevaTarea: NuevaTarea) {
    const dlgDestino = this.dlg.open(FinalizarComponent, {
      maxWidth: '90vw',
      data: nuevaTarea
    });

    dlgDestino.afterClosed().subscribe((result: { success: boolean }) => {
      if (result && result.success) {
        this.successRefresh.emit(true)
      }
    });
  }

  opendDlgReabrirTarea(nuevaTarea: NuevaTarea) {
    const dlgDestino = this.dlg.open(ReabrirComponent, {
      maxWidth: '90vw',
      data: nuevaTarea
    });

    dlgDestino.afterClosed().subscribe((result: { success: boolean }) => {
      if (result && result.success) {
        this.successRefresh.emit(true)
      }
    });
  }

  getSemaforoTarea(nuevaTarea: NuevaTarea): string {
    let classColor = '';

    if (nuevaTarea.estado === 1 || nuevaTarea.estado === 2) {
      return classColor = "gray"
    }

    const currentDate = new Date();
    const maxDate = new Date(nuevaTarea.fechaExpira);

    const differenceInTime = maxDate.getTime() - currentDate.getTime();
    const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));


    // Si está dentro del plazo (mayor a 2 días)
    if (differenceInDays > 2) {
      classColor = 'good';
    }
    // Si está a un día del plazo
    else if (differenceInDays <= 2 && differenceInDays >= 1) {
      classColor = 'warning';
    }
    // Si está fuera del plazo (fecha pasada)
    else if (differenceInDays < 1) {
      classColor = 'danger';
    }

    return classColor;
  }

  redactar(nuevaTarea:NuevaTarea ) {
    const taskData = {
      documentIDs: [nuevaTarea.id]
    }
    this.router.navigateByUrl("/redactar/"+nuevaTarea.id, { state: taskData })
  }

  formatDate(date: string): string {
    return this.dateService.formatCustomStringToDateNoTime(date!)
  }
  formatDateTime(date: string): string {
    return this.dateService.formatCustomStringToDate(date!)
  }
}
